function formIframeCallback(pCode, pFields){
    $(document).trigger('onIframeCallback', [pCode, pFields]);
}

(function () {
    $(document).on('ready', function(){


        function initInputFocus(){
            $(document).on('focus', 'input, textarea', function(e){
                var holder = $(this).attr("placeholder"); var val = $(this).val(); if(val == holder)$(this).val("");
            });

            $(document).on('blur', 'input', function(e){
                var holder = $(this).attr("placeholder"); var val = $(this).val(); if(val == "")$(this).val(holder);
            });
        }
        initInputFocus();


        $(document).on('onIframeCallback', function(e, pCode, pFields){
            if(pCode == "error"){
                $("p.error-msg").fadeIn(250);
                window.formValidator.displayFormAfterVerifyFields("form", "error", pFields.fields, true);
            }else{
                $("p.error-msg").hide();
                $(".confirmation").show();
            }
        });



        if(window.FastClick)window.FastClick.attach(document.body);

        var mySwiper = null;

        $('.show-media-popup').on('mfpClose', function() {
            if(mySwiper)mySwiper.destroy();
            mySwiper = null;
        });
        $('.show-media-popup').on('mfpAjaxContentAdded', function(e /*, params */) {
            if(mySwiper)mySwiper.destroy();
            mySwiper = new Swiper ('.diaporama .swiper-container', {
                direction: 'horizontal',
                direction: 'horizontal',
                loop: false,
                a11y: true,
                autoHeight: true,
                freeMode: false,
                setWrapperSize: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev'
            });
        });



        mySwiperStandAlone = new Swiper ('.is-no-ajax-mode .diaporama .swiper-container', {
            direction: 'horizontal',
            direction: 'horizontal',
            loop: false,
            a11y: true,
            autoHeight: true,
            freeMode: false,
            setWrapperSize: true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev'
        });


       /* $(document).on('click', '.show-media-popup', function(e){
            e.preventDefault();
            var href = $(this).attr('data-href');
            console.log('href', href);
            var $target = $($(this).attr('href'));
            if($target.length > 0){
                $target.load(href, function() {
                    console.log('done');
                });
            }
        });*/


   if($('.homepage-video').length > 0){
        var $video = $('.homepage-video video');
       $video.html('<source src="'+$video.attr('data-src')+'" type="video/mp4" />');
    }



        window.formValidator = {
            validateRegExp:function(pValue, pType){
                var reg;
                switch(pType){
                    case 'mail':
                        reg  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                        break;

                    case 'phone':
                        reg = /!^(\+){0,1}[0-9\/ \-\.]{8,25}$!/;
                        break;

                    default:
                        break;

                }

                if(!is_string(pValue))return true;
                if(!reg)return true;
                if (pValue.match(reg))return true;
                return false;
            },

            verifyField:function(pValue, pType, pIsRequired){
                //valeur de code => ok, required, invalid, existing
                var code = "ok";

                if(pValue == ""){
                    if(pIsRequired){
                        code = "required";
                    }
                }else{
                    if(pType != ""){
                        if(!this.validateRegExp(pValue, pType)){
                            code = "invalid";
                        }
                    }
                }
                return code;
            },

            verifyAllFieldsForm:function(pFields){

                var retour = {};
                var hasError = false;
                var msg = "";

                for(var field in pFields) {
                    var code = this.verifyField(pFields[field].value, pFields[field].type, pFields[field].required);
                    if(code != "ok")hasError = true;
                    retour[field] = {code:code, value:pFields[field].value};
                }
                return {fields:retour, hasError:hasError, msg:msg};
            },


            displayFormAfterVerifyFields:function(pSelecorJquery, pClassNameErrorField, pVerifyFields, pDisplayErrorForLabel){
                //pVerifyFields correspond au tableau de retour de la methode FORM_MANAGER.verifyField(pFields) :

                for(var field in pVerifyFields) {
                    this.displayFormElementByCode(pVerifyFields[field].code, pSelecorJquery + " #" + field, pClassNameErrorField);
                    if(pDisplayErrorForLabel == true)this.displayFormElementByCode(pVerifyFields[field].code, pSelecorJquery + " label[for=" + field+"]", pClassNameErrorField);
                }
            },

            displayFormAllFieldsNoError:function(pSelecorJquery, pClassNameErrorField, pVerifyFields, pDisplayErrorForLabel){
                for(var field in pVerifyFields) {
                    $(pSelecorJquery + " #" + field).removeClass(pClassNameErrorField);
                    if(pDisplayErrorForLabel == true)$( pSelecorJquery + " label[for=" + field+"]").removeClass(pClassNameErrorField);
                }
            },

            displayFormElementByCode:function(pCode, pSelecorJquery, pClassNameErrorField){
                if(pCode == "ok"){
                    $(pSelecorJquery).removeClass(pClassNameErrorField);
                }else{
                    $(pSelecorJquery).addClass(pClassNameErrorField);
                }
            }

        };

    });




    $('.error-detail').hide();
    $(document).on('click', '#error-detail-wrapper a', function(e){
        $('.error-detail').toggle();
        return false;
    });


})();
